import React, {Component} from 'react';
import Const from 'constants';

class BaseSortLineups extends Component {
    getItems() {
        const {sportConfig} = this.props;

        let items = {...Const.FILTER_DASHBOARD_ITEMS};

        if (sportConfig.isModeBacktest()) {
            items[Const.SORT_BY_FINAL_POINTS] = 'Final FPts';
        }

        return {
            ...items,
            ...Const.EXTRA_FILTER_DASHBOARD_ITEMS[sportConfig.getGameType()][sportConfig.getSport()],
        };
    }
}

export default BaseSortLineups;
